import { SET_USER } from '../actions/user';

export default function shipback(state = "", action) {
  switch (action.type) {
    case SET_USER:
      state = action.user
      return state
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/reducers/user.js